"use strict";

/**
 * @classdesc
 * Abstrakte Wrapperklasse für den Style Füllung.
 *
 * @class
 * @abstract
 * @extends gc.gis.GCWrappable
 * @memberof gc.gis.style
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 */
gc.gis.style.GCFill = function()
{
    gc.gis.style.GCAbstractStyle.call(this);
};
gc.gis.style.GCFill.prototype = Object.create(gc.gis.style.GCAbstractStyle.prototype);

/**
 * Setzt die Füllfarbe.
 *
 * @abstract
 * @method
 * @public
 * @param {gc.gis.style.GCColor} color Füllfarbe
 * @return {gc.gis.style.GCFill} this
 */
gc.gis.style.GCFill.prototype.setColor = gc.gis.abstractMethod;

/**
 * Liefert die aktuelle Füllfarbe.
 *
 * @abstract
 * @method
 * @public
 * @return {gc.gis.style.GCColor} Füllfarbe
 */
gc.gis.style.GCFill.prototype.getColor = gc.gis.abstractMethod;